import { Flex, Image } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { useEffect } from 'react';
import { getCookie, setCookie } from 'cookies-next';
import { toast } from 'react-toastify';

import { apiSSO } from '@/lib/axios/apiSSO';
import { api } from '@/lib/axios/api';

import logoImg from '@/assets/images/logo.svg';
import { useSessionStore } from '@/store/session';

const urlSSO = `${import.meta.env.VITE_SSO_BASE_URL}/session?origin=${
  import.meta.env.VITE_SSO_REDIRECT_URI
}&client_id=${import.meta.env.VITE_SSO_CLIENT_ID}`;

export function LoginRedirect() {
  const search = window.location.search;
  const queryParams = queryString.parse(search);
  const navigate = useNavigate();
  const { saveUser } = useSessionStore();

  useEffect(() => {
    async function signInValidations() {
      const tokenCookie = getCookie('@event-monitor-web:token-1.0.1');
      const refreshTokenCookie = getCookie(
        '@event-monitor-web:refreshToken-1.0.1',
      );

      if (tokenCookie && refreshTokenCookie) {
        navigate('/dashboard');
      }

      if (queryParams.error) {
        toast.error(queryParams.error);

        setTimeout(() => {
          window.location.href = urlSSO;
        }, 5000);
      }

      if (queryParams.access_token && queryParams.refresh_token) {
        apiSSO.defaults.headers.Authorization = `Bearer ${queryParams.access_token}`;
        api.defaults.headers.Authorization = `Bearer ${queryParams.access_token}`;

        try {
          const { data } = await apiSSO.get('/user/@me');

          const userProfile = {
            name: data.name,
            email: data.email,
            id: data.id,
          };

          setCookie(
            '@event-monitor-web:token-1.0.1',
            `${queryParams.access_token}`,
            {
              maxAge: 60 * 60 * 24 * 30,
              path: '/',
            },
          );

          setCookie(
            '@event-monitor-web:refreshToken-1.0.1',
            `${queryParams.refresh_token}`,
            {
              maxAge: 60 * 60 * 24 * 30,
              path: '/',
            },
          );

          setCookie(
            '@event-monitor-web:user-1.0.1',
            JSON.stringify(userProfile),
            {
              maxAge: 60 * 60 * 24 * 30,
              path: '/',
            },
          );

          saveUser(userProfile);

          navigate('/dashboard');
        } catch (error) {
          console.error(error);
          toast.error('Erro ao realizar a autenticação');
        }
      }
    }

    signInValidations();
  }, [
    navigate,
    queryParams.access_token,
    queryParams.error,
    queryParams.refresh_token,
    saveUser,
  ]);

  return (
    <Flex
      align="center"
      bg="blue.900"
      h="100vh"
      justify="center"
      px={{ base: '1rem', lg: '0' }}
    >
      <Flex
        bg="white"
        w={{ base: '34.33rem' }}
        rounded="0.625rem"
        py="4rem"
        px={{ base: '2rem', sm: '4rem' }}
        alignItems="center"
        justify="center"
      >
        <Image
          src={logoImg}
          alt="Logo Image"
          w={{ base: '7rem', sm: '9.6rem' }}
          h="4.31rem"
        />
      </Flex>
    </Flex>
  );
}
